import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { CommissionCharge } from "../../../Common/AdviserCharges/Components/CommissionCharge";
import { IAC } from "../../../Common/AdviserCharges/Components/IAC";
import { OAC } from "../../../Common/AdviserCharges/Components/OAC";
import { AdviserChargesContents } from "../../../Common/AdviserCharges/Resource/Contents";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { ChargesOnIllustration } from "../../../Common/AdviserCharges/Components/ChargesOnIlustration";

interface IAdviserChargesProps extends IProcessComponentProps {
    type: SubAccountType;
}

interface IAdviserChargesState {}

export class AdviserCharges extends ProcessComponent<IAdviserChargesProps, IAdviserChargesState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
        };
    };

    public render(): JSX.Element {
        return (
            <>
                <h2>{AdviserChargesContents.AcHeader}</h2>

                <h3 className="heading-underlined">{AdviserChargesContents.ProductLevel}</h3>

                <IAC existingAccount={true} type={this.props.type} {...this.getProps("Contribution")} />

                <OAC existingAccount={true} type={this.props.type} {...this.getProps("Contribution")} />

                <CommissionCharge
                    {...this.getProps("Contribution")}
                    processType={ProcessType.SinglePayment}
                    headAccountHierarchyId={getQueryParameters()["hierarchyid"]}
                />

                <ChargesOnIllustration {...this.getProps("Contribution")} />
            </>
        );
    }
}
